import { useNavigate } from "react-router-dom";
import Button from "@/shared/components/Button";
import LinearLayout from "@/shared/components/LinearLayout";
import { useLogout } from "@/features/auth/services";
import { useProfile } from "@/features/profile/services";

const KycFormPending = () => {
  const navigate = useNavigate();
  const { mutateAsync: logout } = useLogout();
  const { data: profile } = useProfile({
    retry: 1,
    staleTime: 30_000,
  });
  const continueKycUrl = profile?.kycUrl ?? profile?.eduKycUrl ?? null;

  return (
    <div className="w-[350px]">
      <LinearLayout orientation="vertical">
        <div className="mx-auto space-y-6 text-center">
          <h1 className="font-inter w-[272px] mx-auto text-center text-[20px] font-medium leading-[24px] tracking-[0px] text-white opacity-100">
            KYC Verification In Progress
          </h1>
          <p className="font-inter mx-auto w-[320px] text-center text-[14px] font-normal leading-[17px] tracking-[0px] text-white opacity-100">
            Your identity verification is currently being processed. This may
            take a few moments.
          </p>
          <p className="font-inter mx-auto w-[296px] py-10 text-center text-[14px] font-normal leading-[17px] tracking-[0px] text-white opacity-50">
            Please check back later or refresh this page to see the status of
            your verification.
          </p>
          <div className="space-y-3">
            {continueKycUrl ? (
              <Button
                variant="primary"
                fluid
                onClick={() => window.location.assign(continueKycUrl)}>
                Continue KYC
              </Button>
            ) : null}
            <Button
              variant="outlined"
              fluid
              onClick={async () => {
                await logout();
                navigate("/sign-in");
              }}>
              Login with Another Account
            </Button>
          </div>
        </div>
      </LinearLayout>
    </div>
  );
};

export default KycFormPending;
